import Vue from "vue";
import Router from "vue-router";
import store from "./store/";

const AppHeader = () =>
  import(/* webpackChunkName: "Header" */ "./layout/AppHeader.vue");
const AppFooter = () =>
  import(/* webpackChunkName: "Footer" */ "./layout/AppFooter.vue");

const loggedIn = () => {
  return localStorage.getItem("token");
};

Vue.use(Router);
let routeList = [
  {
    path: "/",
    name: "dashboard",
    components: {
      header: AppHeader,
      default: () =>
        import(
          /* webpackChunkName: "p-dashboard" */
          "./pages/Dashboard.vue"
        ),
      footer: AppFooter
    }
  },
  {
    path: "/exam",
    name: "exam",
    components: {
      header: AppHeader,
      default: () =>
        import(
          /* webpackChunkName: "p-ListExam" */
          "./pages/ListExam.vue"
        ),
      footer: AppFooter
    }
  },
  {
    path: "/assessment",
    name: "assessment",
    components: {
      header: AppHeader,
      default: () =>
        import(
          /* webpackChunkName: "p-ListAssessment" */
          "./pages/ListAssessment.vue"
        ),
      footer: AppFooter
    }
  },
  {
    path: "/user-pregnancies",
    name: "user-pregnancies",
    components: {
      header: AppHeader,
      default: () =>
        import(
          /* webpackChunkName: "p-ListUserPregnancies" */
          "./pages/ListUserPregnancies.vue"
        ),
      footer: AppFooter
    }
  },
  {
    path: "/user-pregnancies-data",
    name: "user-pregnancies-data",
    components: {
      header: AppHeader,
      default: () =>
        import(
          /* webpackChunkName: "p-ListUserPregnanciesData" */
          "./pages/ListUserPregnanciesData.vue"
        ),
      footer: AppFooter
    }
  },
  {
    path: "/user-emergencies",
    name: "user-emergencies",
    components: {
      header: AppHeader,
      default: () =>
        import(
          /* webpackChunkName: "p-ListUserEmergencies" */
          "./pages/ListUserEmergencies.vue"
        ),
      footer: AppFooter
    }
  },
  {
    path: "/user-schedules",
    name: "user-schedules",
    components: {
      header: AppHeader,
      default: () =>
        import(
          /* webpackChunkName: "p-ListUserSchedules" */
          "./pages/ListUserSchedules.vue"
        ),
      footer: AppFooter
    }
  },
  {
    path: "/user-evaluations",
    name: "user-evaluations",
    components: {
      header: AppHeader,
      default: () =>
        import(
          /* webpackChunkName: "p-ListUserEvaluations" */
          "./pages/ListUserEvaluations.vue"
        ),
      footer: AppFooter
    }
  },
  {
    path: "/user-assessment",
    name: "user-assessment",
    components: {
      header: AppHeader,
      default: () =>
        import(
          /* webpackChunkName: "p-ListUserAssessment" */
          "./pages/ListUserAssessment.vue"
        ),
      footer: AppFooter
    }
  },
  {
    path: "/psychology",
    name: "psychology",
    components: {
      header: AppHeader,
      default: () =>
        import(
          /* webpackChunkName: "p-user-psychology" */
          "./pages/ListUserPsychology.vue"
        ),
      footer: AppFooter
    }
  },
  {
    path: "/user-examination",
    name: "user-examination",
    components: {
      header: AppHeader,
      default: () =>
        import(
          /* webpackChunkName: "p-ListUserExamination" */
          "./pages/ListUserExamination.vue"
        ),
      footer: AppFooter
    }
  },
  {
    path: "/form-examination",
    name: "form-examination",
    components: {
      header: AppHeader,
      default: () =>
        import(
          /* webpackChunkName: "p-formExamination" */
          "./pages/FormExamination.vue"
        ),
      footer: AppFooter
    }
  },
  {
    path: "/detail-examination",
    name: "detail-examination",
    components: {
      header: AppHeader,
      default: () =>
        import(
          /* webpackChunkName: "p-DetailExamination" */
          "./pages/DetailExamination.vue"
        ),
      footer: AppFooter
    }
  },
  {
    path: "/user-examination/:id",
    name: "user-examination-id",
    components: {
      header: AppHeader,
      default: () =>
        import(
          /* webpackChunkName: "p-ListUserExaminationID" */
          "./pages/ListUserExamination.vue"
        ),
      footer: AppFooter
    }
  },
  {
    path: "/form-maternity",
    name: "form-maternity",
    components: {
      header: AppHeader,
      default: () =>
        import(
          /* webpackChunkName: "p-FormMaternity" */
          "./pages/FormMaternity.vue"
        ),
      footer: AppFooter
    }
  },
  {
    path: "/message",
    name: "message",
    components: {
      header: AppHeader,
      default: () =>
        import(
          /* webpackChunkName: "p-ListMessage" */
          "./pages/ListMessage.vue"
        ),
      footer: AppFooter
    }
  },
  {
    path: "/post",
    name: "post",
    components: {
      header: AppHeader,
      default: () =>
        import(
          /* webpackChunkName: "p-ListPost" */
          "./pages/ListPost.vue"
        ),
      footer: AppFooter
    }
  },
  {
    path: "/form-post",
    name: "form-post",
    components: {
      header: AppHeader,
      default: () =>
        import(
          /* webpackChunkName: "p-form-post" */
          "./pages/FormPost.vue"
        ),
      footer: AppFooter
    }
  },
  {
    path: "/location",
    name: "location",
    components: {
      header: AppHeader,
      default: () =>
        import(
          /* webpackChunkName: "p-ListLocation" */
          "./pages/ListLocation.vue"
        ),
      footer: AppFooter
    }
  },
  {
    path: "/user",
    name: "user",
    components: {
      header: AppHeader,
      default: () =>
        import(
          /* webpackChunkName: "p-user-management" */
          "./pages/ListUser.vue"
        ),
      footer: AppFooter
    }
  },
  {
    path: "/form-user",
    name: "form-user",
    components: {
      header: AppHeader,
      default: () =>
        import(
          /* webpackChunkName: "p-form-user" */
          "./pages/FormUser.vue"
        ),
      footer: AppFooter
    }
  },
  {
    path: "/form-responden",
    name: "form-responden",
    components: {
      header: AppHeader,
      default: () =>
        import(
          /* webpackChunkName: "p-form-responden" */
          "./pages/FormResponden.vue"
        ),
      footer: AppFooter
    }
  },
  {
    path: "/responden",
    name: "responden",
    components: {
      header: AppHeader,
      default: () =>
        import(
          /* webpackChunkName: "p-responden" */
          "./pages/ListResponden.vue"
        ),
      footer: AppFooter
    }
  },
  {
    path: "/docs-user",
    name: "docs-users",
    components: {
      header: AppHeader,
      default: () =>
        import(
          /* webpackChunkName: "p-doc-users" */
          "./pages/ListDocUser.vue"
        ),
      footer: AppFooter
    }
  },
  {
    path: "/docs-faq",
    name: "docs-faq",
    components: {
      header: AppHeader,
      default: () =>
        import(
          /* webpackChunkName: "p-docs-faq" */
          "./pages/ListDocFaq.vue"
        ),
      footer: AppFooter
    }
  },
  {
    path: "/config-general",
    name: "config-general",
    components: {
      header: AppHeader,
      default: () =>
        import(
          /* webpackChunkName: "p-config-general" */
          "./pages/ConfigGeneral.vue"
        ),
      footer: AppFooter
    }
  },
  {
    path: "/report",
    name: "report",
    components: {
      header: AppHeader,
      default: () =>
        import(
          /* webpackChunkName: "p-report" */
          "./pages/Report.vue"
        ),
      footer: AppFooter
    }
  },
  {
    path: "/my-account",
    name: "my-account",
    components: {
      header: AppHeader,
      default: () =>
        import(
          /* webpackChunkName: "p-my-account" */
          "./pages/MyAccount.vue"
        ),
      footer: AppFooter
    }
  },
  
  {
    path: "/privacy-policy",
    name: "privacy-policy",
    component: () =>
      import(
        /* webpackChunkName: "p-privacy-policy" */
        "./pages/PrivacyPolicy.vue"
      )
  },
  
  {
    path: "/login",
    name: "login",
    component: () =>
      import(
        /* webpackChunkName: "p-login" */
        "./pages/Login.vue"
      )
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    component: () =>
      import(
        /* webpackChunkName: "p-forgot-password" */
        "./pages/ForgotPassword.vue"
      )
  },
  {
    path: "/reset-password",
    name: "reset-password",
    component: () =>
      import(
        /* webpackChunkName: "p-reset-password" */
        "./pages/ResetPassword.vue"
      )
  },
  // {
  //   path: "/activation/:UserCode/:vcode",
  //   name: "activation",
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "p-verification-success" */
  //       "./pages/VerificationSuccess.vue"
  //     )
  // },

  {
    path: "*",
    components: {
      default: () =>
        import(/* webpackChunkName: "not-found" */ "./pages/NotFound.vue")
    }
  }
];

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: routeList,
  // linkExactActiveClass: 'active', // default class active
  // linkActiveClass: 'active',      // bisa atur juga
});

router.beforeEach((to, from, next) => {
  console.log(to);
  if (
    to.name == "login" ||
    to.name == "privacy-policy" ||
    to.name == "activation" ||
    to.name == "forgot-password" ||
    to.name == "reset-password"
  ) {
    next();
  } else {
    if (loggedIn) {
      return next();
    } else {
      return next("/login");
    }
  }

  // if (!isLoad) store.dispatch("layanan/getData");
  // if (!isLoad) store.dispatch("resume/getResume");
});

export default router;
